import { hosts } from 'settings';

export const FormResetPassword = {
  bindings: {
    email: '<',
    isUpdate: '<',
    member: '<',
    onSubmit: '&',
    resetPasswordToken: '<',
  },

  template: `
    <form class="voome-form"
      name="form"
      autocomplete="off"
      ng-submit="$ctrl.onSubmit({ data: form.data })"
      novalidate>
      <div ng-hide="$ctrl.member.success">
        <div ng-if="!$ctrl.isUpdate">
          <p class="pb-4">
            Enter your email address to recover your password.
          </p>
          <form-group-row>
            <form-group-left>
              <form-label for="email">Your Email</form-label>
            </form-group-left>
            <form-group-right>
              <form-input
                form="form"
                type="email"
                name="email"
                value="$ctrl.email"
                required="true"
                errors="{
                  required: 'This is a required field.',
                  email: 'Must be a valid email address.',
                }">
              </form-input>
            </form-group-right>
          </form-group-row>
          <form-input
            form="form"
            type="hidden"
            name="callbackUrl"
            value="'${hosts.go}/reset-password'">
          </form-input>
          <form-input
            form="form"
            type="hidden"
            name="theme"
            value="'voome'">
          </form-input>
        </div>
        <div ng-if="$ctrl.isUpdate">
          <p>Create your new password.</p>
          <form-input
            form="form"
            type="hidden"
            name="email"
            value="$ctrl.email">
          </form-input>
          <form-input
            form="form"
            type="hidden"
            name="resetPasswordToken"
            value="$ctrl.resetPasswordToken">
          </form-input>
          <form-group-row>
            <form-group-left>
              <form-label>Email</form-label>
            </form-group-left>
            <form-group-right>
              <div class="pt-1 pl-3">{{ $ctrl.email }}</div>
            </form-group-right>
          </form-group-row>
          <profile-fields-password form="form"></profile-fields-password>
        </div>
      </div>
      <div class="form-group form-row justify-content-end">
        <div ng-class="{
          'col-sm-8': !$ctrl.member.success,
          'w-100 text-center': $ctrl.member.success
        }">
          <span ng-hide="$ctrl.member.success">
            <button-primary ng-type="submit" ng-disabled="form.$invalid">
              Submit
            </button-primary>
            <span class="px-3">|</span>
          </span>
          <a ui-sref="login">Back to login</a>
        </div>
      </div>
    </form>`,
};



// WEBPACK FOOTER //
// ./src/components/FormResetPassword/FormResetPassword.js